<template>
  <div :style="window.width>480 ? 'font-size:12px;' : 'font-size:10px;'">
    <h3
      :style="type==='pie' ? 'text-align:center' : ''"
      v-if="
        sondage_data_resultats[questionId] !== undefined &&
          sondage_data_resultats[questionId].element_type !== 'checkboxes' &&
          sondage_data_resultats[questionId].element_type !== 'orderedChoices'
      "
    >
      {{
        sondage_data_resultats[questionId].donnees.resultats.reduce(
          (a, b) => a + b,
          0
        )
      }}{{ " "
      }}{{
        $tc(
          "results.nb.participant",
          sondage_data_resultats[questionId].donnees.resultats.reduce(
            (a, b) => a + b,
            0
          ) > 1
        )
      }}
    </h3>
    <!-- checkboxes -->
    <h3
      :style="type==='pie' ? 'text-align:center' : ''"
      v-if="
        sondage_data_resultats[questionId] !== undefined &&
          sondage_data_resultats[questionId].element_type === 'checkboxes'
      "
    >
      {{
        sondage_data_resultats[questionId].nbParticipantsCheckboxes
          ? sondage_data_resultats[questionId].nbParticipantsCheckboxes
          : 0
      }}{{ " "
      }}{{
        $tc(
          "results.nb.participant",
          sondage_data_resultats[questionId].nbParticipantsCheckboxes > 1
        )
      }}
    </h3>
    <!-- orderedChoices -->
    <h3
      :style="type==='pie' ? 'text-align:center' : ''"
      v-if="
        sondage_data_resultats[questionId] !== undefined &&
          sondage_data_resultats[questionId].element_type === 'orderedChoices'
      "
    >
      {{
        sondage_data_resultats[questionId].nbParticipantsOrderedChoices
          ? sondage_data_resultats[questionId].nbParticipantsOrderedChoices
          : 0
      }}{{ " "
      }}{{
        $tc(
          "results.nb.participant",
          sondage_data_resultats[questionId].nbParticipantsOrderedChoices > 1
        )
      }}
    </h3>
  </div>
</template>

<script>
export default {
  name: 'SectionTitleOthers',
  props: ['sondage_data_resultats', 'questionId', 'window', 'type']
}
</script>



// WEBPACK FOOTER //
// src/components/resultats/section/SectionTitleOthers.vue